import { z } from 'zod';

/**
 * How an account's credit pace reads: the warehouse's pacing ratio put into
 * five buckets for display. The ratio itself is never recomputed here.
 */
const PaceBucketSchema = z.enum(['severe', 'under', 'on', 'over', 'unknown']);
export type PaceBucket = z.infer<typeof PaceBucketSchema>;

/** The rep-facing Title Case label of each pace bucket. */
export const ACCOUNT_PACE_BUCKET_LABELS: Record<PaceBucket, string> = {
  severe: 'Severely Under Pace',
  under: 'Under Pace',
  on: 'On Pace',
  over: 'Over Pace',
  unknown: 'No Pacing',
};

/**
 * Under 0.5 is severe, under 0.8 is under, up to and including 1.2 is on,
 * above 1.2 is over. A missing or non-finite ratio is unknown.
 */
export function paceBucket(ratio: number | null | undefined): PaceBucket {
  if (ratio == null || !Number.isFinite(ratio)) return 'unknown';
  if (ratio < 0.5) return 'severe';
  if (ratio < 0.8) return 'under';
  if (ratio <= 1.2) return 'on';
  return 'over';
}
